const getPropFromModule = (state, ...props) =>
  state.getIn(['core', 'shopList', ...props]);

export default getPropFromModule;
